export const FacebookColored = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11_235)">
      <path
        d="M22 12.23C22 6.70718 17.5228 2.22998 12 2.22998C6.4772 2.22998 2 6.70718 2 12.23C2 16.9196 5.2288 20.8548 9.5844 21.9356V15.286H7.5224V12.23H9.5844V10.9132C9.5844 7.50958 11.1248 5.93198 14.4664 5.93198C15.1 5.93198 16.1932 6.05638 16.6404 6.18038V8.95038C16.4044 8.92558 15.9944 8.91318 15.4852 8.91318C13.8456 8.91318 13.212 9.53438 13.212 11.1492V12.23H16.4784L15.9172 15.286H13.212V22.1568C18.1636 21.5588 22.0004 17.3428 22.0004 12.23H22Z"
        fill="#0866FF"
      />
      <path
        d="M15.9168 15.2856L16.478 12.2296H13.2116V11.1488C13.2116 9.53404 13.8452 8.91284 15.4848 8.91284C15.994 8.91284 16.404 8.92524 16.64 8.95004V6.18004C16.1928 6.05564 15.0996 5.93164 14.466 5.93164C11.1244 5.93164 9.584 7.50924 9.584 10.9128V12.2296H7.522V15.2856H9.584V21.9352C10.3576 22.1272 11.1668 22.2296 11.9996 22.2296C12.4096 22.2296 12.814 22.2044 13.2112 22.1564V15.2856H15.9164H15.9168Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_235">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(2 2.22998)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FacebookColored;
